module.exports = __webpack_public_path__ + "img/twitter-l.1a51f8e0.svg";